/**
 * Performance Optimizer - BRONCANO
 * Optimiza Core Web Vitals y recursos críticos
 */

// Inicializar cuando TODO esté listo para evitar layout forced
window.addEventListener('load', function() {
    optimizeImages();
    // Remover optimizeWebVitals() - causaba layout forced
    
    // Body ya es visible por defecto en HTML
    console.log('⚡ Performance optimizations loaded');
}, { once: true });

function optimizeImages() {
    // Lazy loading para imágenes
    const images = document.querySelectorAll('img[loading="lazy"]');
    
    if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    img.src = img.dataset.src || img.src;
                    img.classList.remove('lazy');
                    observer.unobserve(img);
                }
            });
        });

        images.forEach(img => imageObserver.observe(img));
    }
}

// Web Vitals optimizations - DISABLED to prevent layout forced
// function optimizeWebVitals() removed - caused premature DOM manipulation